$(document).ready(function(){

  // $(document).on('mouseleave', '#predictive-search', function () {
  //   $(this).hide();
  //   $(this).closest('.thb-secondary-area').find('input.search-field').val('');
  // });

  // $("p.range_price").css('display' , 'block');
  // $(".product-information del ").css('display' , 'block'); 
  
  // $(".product-form__input--color .select_dropdown").change(function() {
  //   var selectedValue = $(this).val();
  //   $("select.select_dropdown option").prop('selected',false);
  //   $(".product-form__input--color .variant__button-label[data_value='"+selectedValue+"']").trigger("click");
  // });
  // $(document).on('click','.product-form__input--color .variant__button-label',function() {
  //     var swatchVal = $(this).attr('data_value');
  //     $(".product-information del ").addClass("hide");
  //     $("select.select_dropdown option").prop('selected',false);
  //     $("select.select_dropdown option[value='"+swatchVal+"']").prop('selected',true);
  //     $("select.select_dropdown option[value='"+swatchVal+"']").text(swatchVal);
  //     let searchParams = new URLSearchParams(window.location.search);
  //     let param_id = searchParams.get('variant');
  //     $(document).find('#setid').val(param_id);
  //     setTimeout(function() {
  //       $("p.range_price").addClass("hide");
  //       $(".product-title-container .price .amount, .product-information del").css('display' , 'block');
  //     }, 1000);
  // });

 // var desTable = $(document).find('.product-short-description table tr:last-child th').html();
  // alert(desTable);
  if( $(document).find('.product-short-description table tr:last-child th').html() == 'Color:'){
    $(document).find('.product-short-description table tr:last-child').css('display','none');
  }
  
  if($(document).find("body").hasClass("template-product")){

   var loadChecked_swatch = $('.product-form__input--color .variant__button-input:checked').attr('data_name');
   $(document).find("ul.metaDate_desc li[data-varTitle='"+loadChecked_swatch+"']").show();
    
    $('#select_dropdown').on('change', function() {
      var selval = $(this).find(":checked").attr('data_opt');
      $(document).find(".product-form__input--color .variant__button-label[data-handlize='"+selval+"']").trigger("click");
    });

    $(document).on('click','.product-form__input--color .variant__button-label',function() {
       var swatchVal = $(this).attr('data-handlize');
        $("ul.metaDate_desc li").each(function() {
            var varTitle = $(this).attr('data-varTitle');
            if( swatchVal == varTitle ){
              $(this).show();
            }else{
              $(this).hide();
            }
        });
       $("#select_dropdown option").prop('selected',false);
       $("#select_dropdown option[data_opt='"+swatchVal+"']").prop('selected',true);
    });
  }
  

  $('.custom_video_slide').slick({
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow arrow_itg"><span ><svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12H18M6 12L11 7M6 12L11 17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>',
    nextArrow: '<button class="slide-arrow next-arrow arrow_itg"><span ><svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12H18M18 12L13 7M18 12L13 17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>',  
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  });
});